module.exports = __webpack_public_path__ + "img/12.50917c31.png";